import { SelectOption } from './clients';
import { Location } from './commons';
import { TranslationKey } from './i18next';

export interface Filters {
  searchTerm?: string | null;
  country?: string | string[] | undefined;
  state?: string | undefined;
  city?: string | undefined;
  hostCountry?: string[] | undefined;
  location?: string | string[] | undefined;
  citizenship?: string | string[] | undefined;
  user?: string[] | undefined;
  busDevId?: string[] | undefined;
  recruiterIds?: string[] | undefined;
  status?: string[] | undefined;
  stage?: string[] | undefined;
  industry?: string[] | undefined;
  skillset?: string[] | undefined;
  domesticOverseas?: string[] | undefined;
  benefits?: boolean | undefined;
  drugTest?: boolean | undefined;
  backCheck?: boolean | undefined;
  tfa?: boolean | undefined;
  page?: number | null;
  pageSize: number;
  sortField?: string | null;
  order?: SortOrders | null;
  education?: string[] | undefined;
  schedule?: string[] | undefined;
  languages?: string[] | undefined;
  clientIds?: string[] | SelectOption[] | undefined;
  ace?: boolean | undefined;
  aceContactIds?: string[] | undefined;
  days?: number;
  date?: string;
  fees?: string[] | undefined;
  clientContactedCheck?: boolean | undefined;
  seekerContactedCheck?: boolean | undefined;
  ambassadorId?: string[] | undefined;
  selectedClientId?: string | null;
  screeningCompleted?: boolean | undefined;
  locations?: Location[] | undefined;
  maxMatched?: boolean;
  tags?: string[];
  jobseekerLocationsCountry?: string;
  jobseekerLocationsState?: string;
  jobseekerLocationsCity?: string;
  jobIds?: string[];
}

export enum SortOrders {
  Asc = 'ascend',
  Desc = 'descend'
}

export interface TimePeriodOption {
  key: string;
  label: TranslationKey;
  days?: number;
}

export interface SimpleOptionType {
  label: string;
  value: string;
  key: string;
}
